export const LOYALTY_FEATURE_KEY = 'loyalty';
